module.exports = __webpack_public_path__ + "img/zdgl.91ed25fc.svg";